import {
  CalendarOutlined,
  CheckCircleFilled,
  ClockCircleFilled,
  EnvironmentOutlined,
  RocketOutlined,
  WarningFilled,
} from "@ant-design/icons";

import { EventData } from "../models/event";
import styles from "./eventCard.module.scss";
import placeholder from "../assets/placeholder.png";
import { dateTimeDisplayFormat } from "../utils/DateAndTimeConvertor";
import StatusBadge from "./StatusBadge";
import {
  EventCardFooterTone,
  getEventCardFooterMessage,
  getEventVenueLabel,
} from "../utils/eventDisplay";

const footerIcons: Record<EventCardFooterTone, typeof ClockCircleFilled> = {
  draft: ClockCircleFilled,
  pending: ClockCircleFilled,
  ready: CheckCircleFilled,
  live: RocketOutlined,
  rejected: WarningFilled,
  scheduled: RocketOutlined,
};

export default function EventCard({
  eventD,
  fn,
}: {
  eventD: EventData;
  fn: () => void;
}) {
  const venueLabel = getEventVenueLabel(eventD);
  const footerMessage = getEventCardFooterMessage(eventD);
  const FooterIcon = footerMessage
    ? footerIcons[footerMessage.tone]
    : ClockCircleFilled;

  return (
    <button type="button" className={styles.card} onClick={fn}>
      <div className={styles.cover}>
        <img
          src={
            Array.isArray(eventD?.banner_image) &&
            eventD?.banner_image.length > 0
              ? eventD?.banner_image?.[0]?.url
              : placeholder
          }
          alt={eventD.name}
        />

        <div className={styles.topTags}>
          <StatusBadge status={eventD?.status} type="event" />
        </div>
      </div>

      <div className={styles.body}>
        <div className={styles.eventMeta}>
          <h3 className={styles.title}>{eventD.name}</h3>

          <div className={styles.dateTime}>
            <CalendarOutlined />
            <span>
              {eventD.start_date && eventD.start_time
                ? dateTimeDisplayFormat(eventD.start_date, eventD.start_time)
                : "Date not set"}
            </span>
          </div>
        </div>

        <div className={styles.venueRow}>
          <EnvironmentOutlined />
          <span>{venueLabel}</span>
        </div>

        {footerMessage && (
          <div className={styles.bottomSection}>
            <div
              className={`${styles.footerMessage} ${styles[`footerMessage_${footerMessage.tone}`]}`}
            >
              <FooterIcon />
              <span>{footerMessage.text}</span>
            </div>
          </div>
        )}
      </div>
    </button>
  );
}
